import { GridApi } from 'ag-grid-community';
import { t } from 'i18next';
import { calculateEvolutionInPercentage } from 'routes/BudgetModule/components/BudgetProposal/Resource/ExpenseIncome/gridHelpers/evolutionHelpers';
import { getValueFormatter, excelFormatters } from 'ui/AgGridReact/formatters';

/**
 * Export AgGrid PivotGrid data as excel.
 */
export const exportPivotGridAsExcel = (gridApi: GridApi | null) => {
    // FIXME: aggrid_refacto. This component is generic and should not be aware of the evolution column!
    gridApi?.exportDataAsExcel({
        processCellCallback: (params) => {
            if (
                params.value &&
                typeof params.value === 'object' &&
                params.value.totalAmountRequested !== undefined
            ) {
                // Evolution needs to be computed here since
                // the value is just an object
                return calculateEvolutionInPercentage(
                    params.value.totalAmountRequested,
                    params.value.totalAmountVoted,
                    t,
                );
            }
            // ValueFormatter is not included in the Excel export, so we need to get it from the ColDef and reapply it here.
            // see here: https://stackoverflow.com/questions/45791557/exporting-to-excel-with-proper-cell-formatting-on-ag-grid
            const valueFormatter = getValueFormatter(params);
            if (valueFormatter && excelFormatters.includes(valueFormatter)) {
                return valueFormatter(params);
            }

            return params.value;
        },
    });
};
